export default function NoBreak({ children }) {
	return <span style={{ whiteSpace: "nowrap" }}>{children}</span>;
}
